import { createAction, props } from '@ngrx/store';
import { WebSiteConfig } from './ubs-config-model';

export const retrieveWebSiteConfig = createAction(
 '[WebSiteConfig/API] Retrieve WebSiteConfig Success',
 props<{webSiteConfig:WebSiteConfig}>()   
)

export const retrieveEnv = createAction(
    '[Env] Retrieve Env Success',
    props<{env:any}>()
)